import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import {
  ClinicPlatformBillingInvoiceDto, ClinicPlatformBillingStatusDto, PayInvoiceResultDto,
} from '../../dtos/platform-billing.dto';

@Injectable()
export class PlatformBillingRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getStatus(organizationId: number): Observable<ClinicPlatformBillingStatusDto> {
    return this.http.get<ClinicPlatformBillingStatusDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizations.platformBillingStatus(organizationId)}`,
    );
  }

  public getInvoices(organizationId: number, take: number): Observable<readonly ClinicPlatformBillingInvoiceDto[]> {
    return this.http.get<readonly ClinicPlatformBillingInvoiceDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.organizations.platformBillingInvoices(organizationId)}`,
      { params: { take } },
    );
  }

  public downloadInvoice(organizationId: number, chargeId: string): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}${API_ENDPOINTS.organizations.platformBillingInvoicePdf(organizationId, chargeId)}`,
      { responseType: 'blob' },
    );
  }

  public payNow(organizationId: number, chargeId: string): Observable<PayInvoiceResultDto> {
    return this.http.post<PayInvoiceResultDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizations.platformBillingPay(organizationId, chargeId)}`,
      null,
    );
  }

  public confirmPay(organizationId: number, chargeId: string): Observable<PayInvoiceResultDto> {
    return this.http.post<PayInvoiceResultDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizations.platformBillingConfirmPay(organizationId, chargeId)}`,
      null,
    );
  }
}
